export const stripe_key = process.env.REACT_APP_ENVIRONMENT === 'development' ? 'pk_test_DRwR1dWFkuYCfQA6KxecpfuZ00Pmg7Zwxo' : 'pk_live_rfBRmdbF2K2Lf2CoHqm3dqeh0004jMwzwB'
